import type { UserStatsResponse } from '@coorum-research/shared-common/api-response/user-stats.schema'
import http from '../apis/http'

export const userStatsApi = () => {
  const getUserStats = async (tagIds: string[]) => {
    const response = await http.get<UserStatsResponse>(`/user-stats`, { params: { tagIds }, paramsSerializer: { indexes: null } })

    return response.data
  }

  return {
    getUserStats,
  }
}
